import { isEuOrUk } from "./euDetect";

/**
 * Three-state consent for non-essential tracking (cookie UUID +
 * FingerprintJS visitor hash). EU/UK visitors start at "pending"
 * until they interact with the banner; everyone else is "granted"
 * by default (legitimate interest; no banner shown).
 */

export type ConsentStatus = "granted" | "denied" | "pending";

const STORAGE_KEY = "ev_cookie_consent";

export function getConsent(): ConsentStatus {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === "granted" || v === "denied") return v;
  } catch {}
  return isEuOrUk() ? "pending" : "granted";
}

export function setConsent(v: "granted" | "denied") {
  try {
    localStorage.setItem(STORAGE_KEY, v);
    window.dispatchEvent(new CustomEvent("ev-consent-change", { detail: v }));
  } catch {}
}

/** Observe consent changes without a full React context. */
export function onConsentChange(cb: (v: ConsentStatus) => void): () => void {
  const handler = () => cb(getConsent());
  window.addEventListener("ev-consent-change", handler);
  return () => window.removeEventListener("ev-consent-change", handler);
}
